import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { Navbar, Footer } from "../../components/Layout";
import { toast, Toaster } from "sonner";
import { ArrowLeft, Send, MessageSquare } from "lucide-react";

export default function MessagesAdmin() {
  const navigate = useNavigate();
  const [threads, setThreads] = useState([]);
  const [active, setActive] = useState(null);
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");

  const loadThreads = () => api.get("/admin/messages").then(r => setThreads(r.data));
  const loadThread = (tid) => api.get(`/admin/messages?thread_id=${tid}`).then(r => setMessages(r.data));

  useEffect(() => { loadThreads(); }, []);
  useEffect(() => { if (active) loadThread(active.thread_id); }, [active]);

  const send = async () => {
    if (!text.trim() || !active) return;
    try {
      await api.post("/admin/messages", { thread_id: active.thread_id, content: text });
      setText(""); loadThread(active.thread_id); loadThreads();
    } catch { toast.error("Échec envoi"); }
  };

  return (
    <div className="min-h-screen" style={{ background: "var(--bg-default)" }}>
      <Navbar /><Toaster richColors position="top-right" />
      <section className="max-w-6xl mx-auto px-6 md:px-8 py-12">
        <button onClick={() => navigate("/admin")} className="text-xs font-bold uppercase tracking-widest mb-6 flex items-center gap-2"><ArrowLeft className="w-3 h-3"/> Retour</button>
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight mb-8">Messagerie</h1>

        <div className="grid lg:grid-cols-[300px_1fr] gap-6" data-testid="messages-layout">
          <aside className="bg-[color:var(--bg-surface)] border" style={{ borderColor: "var(--border-default)" }}>
            <h3 className="font-display font-bold p-4 border-b border-slate-900/10 text-sm">Conversations</h3>
            {threads.length === 0 && <div className="p-6 text-xs text-center opacity-50">Aucune conversation.</div>}
            {threads.map(t => (
              <button key={t.thread_id} onClick={() => setActive(t)} data-testid={`thread-${t.thread_id}`}
                className={`w-full text-left p-4 border-b border-slate-900/5 hover:bg-[#FFC107]/10 ${active?.thread_id === t.thread_id ? "bg-[#FFC107]/30" : ""}`}>
                <div className="font-bold text-sm flex items-center justify-between">{t.tenant?.name || "Locataire"} {t.unread > 0 && <span className="bg-red-600 text-white text-[10px] px-1.5 py-0.5 rounded-full">{t.unread}</span>}</div>
                <div className="text-xs opacity-60 truncate">{t.last_message?.content}</div>
              </button>
            ))}
          </aside>

          <div className="bg-[color:var(--bg-surface)] border flex flex-col" style={{ borderColor: "var(--border-default)", minHeight: 500 }}>
            {!active ? (
              <div className="flex-1 flex items-center justify-center opacity-50 text-sm"><MessageSquare className="w-5 h-5 mr-2"/> Sélectionnez une conversation</div>
            ) : (
              <>
                <div className="p-4 border-b border-slate-900/10 font-bold">{active.tenant?.name}</div>
                <div className="flex-1 p-4 overflow-y-auto space-y-3" data-testid="messages-list">
                  {messages.map(m => (
                    <div key={m.id} className={`max-w-[70%] ${m.from_role === "admin" ? "ml-auto" : ""}`}>
                      <div className={`p-3 text-sm ${m.from_role === "admin" ? "bg-slate-900 text-white" : "bg-[#FFC107]/30"}`}>{m.content}</div>
                      <div className="text-[10px] opacity-50 mt-1">{m.from_name} · {new Date(m.created_at).toLocaleString("fr-FR")}</div>
                    </div>
                  ))}
                </div>
                <div className="p-4 border-t border-slate-900/10 flex gap-2">
                  <input value={text} onChange={e => setText(e.target.value)} onKeyDown={e => e.key === "Enter" && send()} placeholder="Votre message..." className="input flex-1" data-testid="admin-msg-input" />
                  <button onClick={send} data-testid="admin-msg-send" className="btn-brutal btn-brutal-solar px-4 py-2 text-sm font-bold uppercase tracking-wider flex items-center gap-1"><Send className="w-4 h-4"/> Envoyer</button>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
